import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Realm from 'realm-web';
import { useFormik } from 'formik';
import { Col, Form, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import s from '../LogIn/styles';
import InputPassword from '../../components/common/InputPassword';
import Button from '../../components/common/Button';
import Colors from '../../assets/Colors';

function UpdaterAccountConfirm() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const navigate = useNavigate();
  const { handleChange, values, errors, handleSubmit } = useFormik({
    initialValues: {
      password: '',
      repeatPassword: '',
      token: params.get('token'),
      tokenId: params.get('tokenId'),
    },
    onSubmit: () => {
      const app = new Realm.App(process.env.REACT_APP_UPDATER_APP_ID);
      app.emailPasswordAuth
        .confirmUser({
          token: params.get('token'),
          tokenId: params.get('tokenId'),
        })
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          navigate('/500');
        });
    },
  });

  useEffect(() => {
    if (!params.get('token') || !params.get('tokenId')) {
      navigate('/505');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  if (loading) {
    return <h2>{t('containers.UpdaterChangePassword.wait')}</h2>;
  }
  return (
    <Row>
      <Col xs={24} md={12}>
        <s.formContainer>
          <Form
            style={{ marginTop: '32px' }}
            autoComplete="off"
            onSubmitCapture={handleSubmit}
          >
            <s.SubTitle>
              {t('containers.UpdaterChangePassword.newPassword')}
            </s.SubTitle>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                },
              ]}
              style={{ marginBottom: 0 }}
              validateStatus={errors.password ? 'error' : ''}
            >
              <InputPassword values={values.password} onChange={handleChange} />
            </Form.Item>

            <s.SubTitle>
              {t('containers.UpdaterChangePassword.repeatPassword')}
            </s.SubTitle>
            <Form.Item
              name="repeatPassword"
              rules={[
                {
                  required: true,
                },
              ]}
              style={{ marginBottom: 0 }}
              validateStatus={errors.password ? 'error' : ''}
            >
              <InputPassword values={values.password} onChange={handleChange} />
            </Form.Item>
          </Form>
        </s.formContainer>

        <Form.Item style={{ marginTop: 32 }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              background: Colors.primary_web,
              opacity:
                values.token && values.password && values.email ? 1 : 0.5,
              color: Colors.text_on_secondary,
            }}
          >
            {t('containers.UpdaterChangePassword.accept')}
          </Button>
        </Form.Item>
      </Col>
    </Row>
  );
}

export default UpdaterAccountConfirm;
